<template>
  <b-card>
    <b-row>
      <b-col>
        <b-form-group label="Beschikbaarheid">
          <b-input v-model="afspraken.beschikbaarheid" />
        </b-form-group>
        <b-form-group label="Storingen">
          <b-input v-model="afspraken.storingen" />
        </b-form-group>
        <b-form-group label="Afwijking percentage">
          <b-input v-model="afspraken.afwijking" />
        </b-form-group>
        <b-form-group label="Minimale onderhoudsduur">
          <b-input v-model="afspraken.keo.minimale_duur" />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Responsetijd">
          <b-input v-model="afspraken.reactietijd" />
        </b-form-group>
        <b-form-group label="Stilstandtijd">
          <b-input v-model="afspraken.stilstand" />
        </b-form-group>
        <b-form-group label="Herhalingspunten">
          <b-input v-model="afspraken.herhaalpunten" />
        </b-form-group>
        <b-form-group label="Kpi score %">
          <b-input-group>
            <b-input-group-text class="bg-success">
              3
            </b-input-group-text>
            <b-input 
              v-model.number="afspraken.percentages[0]" 
              class="ml-4"
            />
            <b-input-group-text>%</b-input-group-text>
            <b-input-group-text class="mx-4 bg-warning">
              2
            </b-input-group-text>
            <b-input v-model.number="afspraken.percentages[1]" />
            <b-input-group-text class="mr-4">
              %
            </b-input-group-text>
            <b-input-group-text class="bg-danger">
              1
            </b-input-group-text>
          </b-input-group> 
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col 
        v-for="onderhoud in afspraken.keo.onderhoud" 
        :key="onderhoud.stopplaatsen"
      >
        <b-input-group>
          <b-input-group-text>Stopplaatsen >= {{ onderhoud.stopplaatsen }}</b-input-group-text>
          <b-input v-model="onderhoud.beurten" />
        </b-input-group>
      </b-col>
    </b-row>
    <!-- 0: {{ getBeurtenKeo(0) }}<br>
    1: {{ getBeurtenKeo(1) }}<br>
    2: {{ getBeurtenKeo(2) }}<br>
    3: {{ getBeurtenKeo(3) }}<br>
    4: {{ getBeurtenKeo(4) }}<br> 
    6: {{ getBeurtenKeo(6) }}<br>
    13: {{ getBeurtenKeo(14) }}<br> -->
  </b-card>
</template>
<script>
export default {
    name: 'KpiInstellingen',
    components: {},
    mixins: [],
    props: {
        afspraken: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return  {
            score: 0,
            toggle: false
        }
    },
    computed: {
    },
    watch: {},
    mounted () {
        
    },
    methods: {
        kpiScore(percentage) {
            // kpi score op basis van percentages;
            if (percentage >= this.afspraken.percentages[0]) return 3;
            if (percentage >= this.afspraken.percentages[1]) return 2;
            return 1;
        },
        getBeurtenKeo(aantalstopplaatsen) {
            let beurten = 0;
            if (this.afspraken == null) return beurten;
            // bepaal het aantal beurten, max stopplaatsen is een ordered list
            // dus als aantalstopplaatsen groter is dan de stopplaatsen van de eerste
            // dan is het aantal beurten van de eerste
            this.afspraken.keo.onderhoud.forEach((onderhoud) => {
                if (aantalstopplaatsen >= onderhoud.stopplaatsen) {
                    beurten = onderhoud.beurten;
                    return;
                }
            });
            return Number(beurten);
        },
    },
          
}
</script>